<template>
    <div id="certificacao-bloco-informacao">
        <div class="certificacao-bloco-informacao__interno">
            <div class="bloco-informacao-certificacao__interno-texto">
                <span>{{ titulo }}</span>
                <span>{{ subtitulo }}</span>
            </div>
            <div class="bloco-informacao-certificacao__interno-numero">
                <span>{{ numero || 0 }}</span>
                <span>{{ sigla }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlocoInformacaoCertificacao',
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        subtitulo: {
            type: String,
            default: () => ''
        },
        numero: {
            type: [String, Number],
            default: () => ''
        },
        sigla: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
#certificacao-bloco-informacao {
    flex-grow: 1;
    min-width: 20%;
    background: var(--white);
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--primary);
    box-shadow: 0 0 2px 0 rgb(0 65 60 / 20%);
    padding: 17px 10px;
    flex-wrap: nowrap;
    gap: 10px;
    width: 100%;
    height: 89px;

    .certificacao-bloco-informacao__interno {
        display: flex;
        width: 100%;

        .bloco-informacao-certificacao__interno-texto {
            display: flex;
            width: 100%;
            flex-direction: column;
            justify-content: center;
            span {
                width: 100%;
                padding: 3px;
                font-weight: 600;
            }
        }
    }

    .bloco-informacao-certificacao__interno-numero {
        span {
            font-size: 28px;
            font-weight: 600;
        }
    }

    span {
        padding: 3px;
        &.bloco-informacao-certificacao__interno-texto {
            span {
                padding: 3px;
                font-weight: 600;
            }
        }
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
</style>
